<app-filter-panel [fields]="fieldsConfig" (search)="search()"></app-filter-panel>

<!--
<div class="flex gap-2 input-field">
    <input pInputText placeholder="Nombre" [(ngModel)]="filters.name.value" (keydown.enter)="search()" class="w-full" />
    <i *ngIf="filters.name.value" class="pi pi-times cursor-pointer" (click)="filters.name.value = null; search()"></i>
      <!- -<input pInputText placeholder="Evento" [(ngModel)]="filters.nameEvent.value" (keydown.enter)="search()" class="w-full" />
    <p-dropdown [(ngModel)]="filters.automationEventId.value" [options]="contracts" optionLabel="name" optionValue="id" appendTo="body" [filter]="true" filterBy="name" placeholder="Evento" d-form-field-error  (onChange)="search()" ></p-dropdown>
    <i *ngIf="filters.automationEventId.value" class="pi pi-times cursor-pointer" (click)="filters.nameEvent.value = null; search()"></i>- ->
    <p-dropdown placeholder="Compañía" [options]="companies" optionLabel="name" optionValue="id" [(ngModel)]="filters.companyId.filter.value" (onChange)="loadContracts()" showClear  class="w-full" />
    <p-dropdown [(ngModel)]="filters.contractId.filter.value" [options]="contracts" optionLabel="name" optionValue="id" appendTo="body" [filter]="true" filterBy="name" placeholder="Contrato"  (onChange)="search()"  class="w-full"></p-dropdown>
</div>
-->

<p-table #grid [value]="automations" [lazy]="true" (onLazyLoad)="loadData($event)" [loading]="loading"
  [paginator]="true" [rows]="25" [totalRecords]="totalRecords" [showCurrentPageReport]="true"
  currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
  [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
  <ng-template pTemplate="header" let-columns>
      <tr>
          <th pSortableColumn="name">Nombre <p-sortIcon field="name"></p-sortIcon></th>
          <th pSortableColumn="automationEvent.name">Evento <p-sortIcon field="automationEvent.name"></p-sortIcon></th>
          <th pSortableColumn="enabled">Activa <p-sortIcon field="enabled"></p-sortIcon></th>
          <th width="100"></th>
      </tr>
  </ng-template>
  <ng-template pTemplate="body" let-automation let-columns="columns">
      <tr (dblclick)="edit(automation)">
          <td>{{automation.name}}</td>
          <td>{{automation.automationEvent.name}}</td>
          <td>                
            <i class="pi" [ngClass]="{ 'text-green-500 pi-check-circle': automation.enabled, 'text-red-500 pi-times-circle': !automation.enabled }"></i>
          </td>
          <td>
              <div class="flex gap-2 justify-content-end">
                  <p-button *ngIf="allowDelete" (click)="delete(automation)" [rounded]="true" [text]="false"
                      severity="danger"><i class="pi pi-trash"></i></p-button>
                  <p-button *ngIf="allowWrite" (click)="edit(automation)" [rounded]="true" [text]="false"><i
                          class="pi pi-pencil"></i></p-button>
              </div>
          </td>
      </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage" let-columns>
    <tr>
      <td [attr.colspan]="3">        
         No se han encontrado calendarios
      </td>
    </tr>
  </ng-template>
</p-table>

<p-confirmDialog></p-confirmDialog>